/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AdminContainer from "../../components/ui/AdminContainer";
import AdminForm from "../../components/ui/AdminForm";
import InputIcon from "../../components/form/elements/InputIcon";
import { isAdminUsers, isMultiYear } from "../../services/defaultSettings";
import { years } from "../../services/yearSevices";
import {
    handleCrud,
    handleFormSubmit,
    handleInputChange as handleChange,
    renderInputFields,
} from "../../services/formServices";
import auth from "../../services/authServices";
import http from "../../services/httpServices";

import { submitTypes } from "../../services/adminServices";
const initialState = {
    name: "",
    description: "",
    is_visible: 1,
    is_free: 0,
    is_closed: 0,
    has_moderators: 0,
    moderators_id: [],
    is_required_approvment_to_post: 1,
    is_non_subscribed_able_to_view: 0,
    is_non_subscribed_able_to_contribute: 0,
    is_user_able_to_comment: 1,
    year: 3,
    courses_id: [],
    submit_type: 0,
    community_category_id: 0,
    is_only_recent_subscribers_able_to_contribute: 0,
    recent_subscription_days: 30,
};

const CommunityCategoryEditing = () => {
    const [data, setData] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [allCourses, setAllCourses] = useState([]);
    const [admins, setAdmins] = useState([]);

    const [inputFields, setInputFields] = useState([]);

    const [communityCategories, setCommunityCategories] = useState([]);

    const getCourses = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(`/api/courses/options`, config);
        setAllCourses(response);
        return response;
    };

    // Filter courses by year on client side
    const getFilteredCourses = (year) => {
        if (!year || allCourses.length === 0) return [];
        return allCourses.filter((course) => course.year === year);
    };

    const setYearFromCourses = (coursesList, selectedCourseIds) => {
        if (
            selectedCourseIds &&
            selectedCourseIds.length > 0 &&
            coursesList &&
            coursesList.length > 0
        ) {
            const firstSelectedCourse = coursesList.find((course) =>
                selectedCourseIds.includes(course.value)
            );
            if (firstSelectedCourse && firstSelectedCourse.year) {
                setData((prevData) => ({ ...prevData, year: firstSelectedCourse.year }));
            }
        }
    };

    const getCommunityCategories = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(`/api/community_categories/options`, config);

        setCommunityCategories(response);
    };
    const getCommunityCategoryInfo = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(
            `/api/community_categories/${data.community_category_id}`,
            config
        );

        let result = { ...response };
        // Object.keys(response).forEach((element) => {
        //     if (["name", "description", "division_id"].includes(element)) {
        //         result[element] = response[element];
        //     }
        // });

        setData({ ...data, ...result });

        // For update mode, get all courses and then set year from first course
        if (data.submit_type === "update") {
            const coursesResponse = await getCourses();
            if (result.courses_id && result.courses_id.length > 0 && coursesResponse) {
                setYearFromCourses(coursesResponse, result.courses_id);
            }
        }
    };
    const getAdmins = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);
        const { data: response } = await http.get(`/api/admins`, config);

        let adminOptions = response.map((user) => {
            return { value: user.id, text: user.full_name + ` (@${user.email})` };
        });
        setAdmins(adminOptions);
    };
    useEffect(() => {
        // Get all courses once when component mounts or submit type changes
        if (data.submit_type) {
            getCourses();
            if (data.submit_type === "store") {
                setData({ ...data, courses_id: [] });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.submit_type]);
    useEffect(() => {
        getAdmins();
    }, []);

    // Reset year and courses_id when community category changes
    useEffect(() => {
        if (data.submit_type === "update" && data.community_category_id > 0) {
            setData((prevData) => ({
                ...prevData,
                courses_id: [],
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.community_category_id]);

    useEffect(() => {
        let fields = [
            {
                id: "submit_type",
                placeholder: "هتعمل ايه دلوقتي",
                type: "select",
                options: submitTypes,
            },
        ];
        if (data.submit_type) {
            if (data.submit_type !== "store" && data.submit_type) {
                fields = [
                    ...fields,
                    {
                        id: "community_category_id",
                        placeholder: "اختر المجموعة",
                        type: "select",
                        options: communityCategories,
                    },
                ];

                if (data.submit_type === "update") {
                    if (data.community_category_id > 0) {
                        fields = [
                            ...fields,
                            {
                                id: "name",
                                placeholder: "العنوان",
                                icon: <InputIcon icon="fluent:app-title-24-filled" />,
                            },
                            {
                                id: "description",
                                placeholder: "الوصف",
                                type: "textarea",
                                icon: <InputIcon icon="ant-design:info-circle-twotone" />,
                            },
                        ];

                        fields = [
                            ...fields,
                            {
                                id: "is_visible",
                                placeholder: "مجموعة ظاهرة",
                                type: "switch",
                            },
                            {
                                id: "is_closed",
                                placeholder: "مجموعة مغلقة (لا يمكن لأحد المشاركة)",
                                type: "switch",
                            },
                            {
                                id: "is_user_able_to_comment",
                                placeholder: "السماح للمستخدمين بكتابة تعليقات",
                                type: "switch",
                            },
                        ];
                        if (isAdminUsers) {
                            fields = [
                                ...fields,
                                {
                                    id: "has_moderators",
                                    placeholder: "مجموعة لمسئول او اكثر فقط",
                                    type: "switch",
                                },
                                {
                                    id: "moderators_id",
                                    placeholder: "اختر المسئول",
                                    options: admins,
                                    isDisabled: !data.has_moderators,
                                    multiple: true,
                                    type: "select",
                                },
                            ];
                        }
                        fields = [
                            ...fields,
                            {
                                id: "is_required_approvment_to_post",
                                placeholder: "يجب موافقة الأدمن على البوست",
                                type: "switch",
                            },

                            {
                                id: "is_free",
                                placeholder: "مجموعة مجانية",
                                type: "switch",
                            },
                        ];

                        if (isMultiYear) {
                            fields = [
                                ...fields,
                                {
                                    id: "year",
                                    placeholder: "اختر الصف الدراسي",
                                    type: "select",
                                    options: years,
                                    isDisabled: data.is_free,
                                },
                            ];
                        }

                        fields = [
                            ...fields,
                            {
                                id: "courses_id",
                                placeholder: "اختر الكورس",
                                options: getFilteredCourses(data.year),
                                isDisabled: data.is_free,
                                multiple: true,
                                type: "select",
                            },
                            {
                                id: "is_only_recent_subscribers_able_to_contribute",
                                placeholder: "المشتركين حديثًا فقط يمكنهم المشاركة؟",
                                isDisabled: data.is_free,
                                type: "switch",
                            },
                            {
                                id: "recent_subscription_days",
                                placeholder: "مدة الاشتراك حديثًا",
                                isDisabled:
                                    data.is_free ||
                                    !data.is_only_recent_subscribers_able_to_contribute,
                                type: "number",
                            },
                            {
                                id: "is_non_subscribed_able_to_view",
                                placeholder: "مجموعة ظاهرة لغير المشتركين",
                                isDisabled: data.is_free,
                                type: "switch",
                            },
                            {
                                id: "is_non_subscribed_able_to_contribute",
                                placeholder: "غير المشتركين قابلين للمشاركة",
                                isDisabled: data.is_free,
                                type: "switch",
                            },
                        ];
                    }
                }
            }
            if (data.submit_type === "store") {
                fields = [
                    ...fields,
                    {
                        id: "name",
                        placeholder: "العنوان",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                    },
                    {
                        id: "description",
                        placeholder: "الوصف",
                        type: "textarea",
                        icon: <InputIcon icon="ant-design:info-circle-twotone" />,
                    },
                ];
                fields = [
                    ...fields,
                    {
                        id: "is_visible",
                        placeholder: "مجموعة ظاهرة",
                        type: "switch",
                    },
                    {
                        id: "is_closed",
                        placeholder: "مجموعة مغلقة (لا يمكن لأحد المشاركة)",
                        type: "switch",
                    },
                    {
                        id: "is_user_able_to_comment",
                        placeholder: "السماح للمستخدمين بكتابة تعليقات",
                        type: "switch",
                    },
                ];
                if (isAdminUsers) {
                    fields = [
                        ...fields,
                        {
                            id: "has_moderators",
                            placeholder: "مجموعة لمسئول او اكثر فقط",
                            type: "switch",
                        },
                        {
                            id: "moderators_id",
                            placeholder: "اختر المسئول",
                            options: admins,
                            isDisabled: !data.has_moderators,
                            multiple: true,
                            type: "select",
                        },
                    ];
                }
                fields = [
                    ...fields,
                    {
                        id: "is_required_approvment_to_post",
                        placeholder: "يجب موافقة الأدمن على البوست",
                        type: "switch",
                    },

                    {
                        id: "is_free",
                        placeholder: "مجموعة مجانية",
                        type: "switch",
                    },
                ];

                if (isMultiYear) {
                    fields = [
                        ...fields,
                        {
                            id: "year",
                            placeholder: "اختر الصف الدراسي",
                            type: "select",
                            options: years,
                            isDisabled: data.is_free,
                        },
                    ];
                }

                fields = [
                    ...fields,
                    {
                        id: "courses_id",
                        placeholder: "اختر الكورس",
                        options: getFilteredCourses(data.year),
                        isDisabled: data.is_free,
                        multiple: true,
                        type: "select",
                    },
                    {
                        id: "is_only_recent_subscribers_able_to_contribute",
                        placeholder: "المشتركين حديثًا فقط يمكنهم المشاركة؟",
                        isDisabled: data.is_free,
                        type: "switch",
                    },
                    {
                        id: "recent_subscription_days",
                        placeholder: "مدة الاشتراك حديثًا",
                        isDisabled:
                            data.is_free || !data.is_only_recent_subscribers_able_to_contribute,
                        type: "number",
                    },
                    {
                        id: "is_non_subscribed_able_to_view",
                        placeholder: "مجموعة ظاهرة لغير المشتركين",
                        isDisabled: data.is_free,
                        type: "switch",
                    },
                    {
                        id: "is_non_subscribed_able_to_contribute",
                        placeholder: "غير المشتركين قابلين للمشاركة",
                        isDisabled: data.is_free,
                        type: "switch",
                    },
                ];
            }
        }

        setInputFields(fields);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allCourses,
        admins,
        // data.courses_id,
        data.submit_type,
        data.community_category_id,
        communityCategories,
        data.is_free,
        data.is_only_recent_subscribers_able_to_contribute,
        data.has_moderators,
        data.year,
    ]);

    useEffect(() => {
        if (data.submit_type !== "store" && data.submit_type) {
            getCommunityCategories();
        }
    }, [data.submit_type]);
    useEffect(() => {
        if (data.community_category_id > 0) {
            getCommunityCategoryInfo();
        }
    }, [data.community_category_id, data.submit_type]);

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, () => {
            const adminToken = auth.getAdminToken();
            const config = auth.getAdminAuthConfig(adminToken);
            const crudApiEndPoint = "/api/community_categories";
            const crudItemName = "مجموعة المنتدى";
            handleCrud(
                config,
                data,
                crudApiEndPoint,
                crudItemName,
                setIsLoading,
                setErrors,
                setData,
                initialState,
                data.community_category_id
            );
        });
    };
    return (
        <AdminContainer>
            <AdminForm
                onSubmit={handleSubmit}
                isLoading={isLoading}
                buttonText="auto"
                submitType={data.submit_type}
            >
                {inputFields.map((input, key) =>
                    renderInputFields(
                        key,
                        input.handleChange ? input.handleChange : handleChange,
                        data,
                        setData,
                        errors,
                        input
                    )
                )}
            </AdminForm>
        </AdminContainer>
    );
};

export default CommunityCategoryEditing;
